/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export * from './assigned/index';
export * from './user-group-permission-list.component';
export * from './user-group-permission-list.module';
export * from './user-group-permission-list.service';
